<template>
  <div>
<!--    <v-row class="pt-4" order="1">-->
<!--      <v-col>-->
<!--        <v-btn large class="ma-3" width="200px">-->
<!--          <v-btn large class=" ma-3" to="form" width="200px">فرم پرداخت الکترونیکی</v-btn>-->
<!--        </v-btn>-->
<!--      </v-col>-->

<!--      <v-col>-->
<!--        <v-btn large class=" ma-3" to="track" width="200px"-->
<!--        >رهگیری پرداخت الکترونیکی</v-btn>-->
<!--      </v-col>-->

<!--      <v-col>-->
<!--        <v-btn large class=" ma-3" to="report" width="200px"-->
<!--        >گزارش وجوه</v-btn-->
<!--        >-->
<!--      </v-col>-->
<!--    </v-row>-->
    <v-row class="justify-center " order="2">
      <v-col cols="12" sm="12"  md="6" class="mr-xs-6">
        <v-row class="justify-center">
          <v-col cols="12" xs="4" sm="4"  >
            <v-img width="80%" height="80%" src="../assets/images/logo.gif"></v-img>
          </v-col>

          <v-col cols="12" xs="4" sm="4"  >
            <v-img width="80%" height="80%" src="../assets/images/BPM.gif"></v-img>
          </v-col>

          <v-col cols="12" xs="4" sm="4"  ></v-col>

        </v-row>

      </v-col>

    </v-row>


    <v-card class=" ma-4" elevation="10" shaped outlined>
      <v-row class="ma-4"
        >
        <v-col cols="12">
          <h3>نکات امنیتی پرداخت الکترونیکی</h3>
          <p>
            دانشگاه صنعتی شریف و بانك هيچگاه و به هيچ طريقي (تلفني، پيامكي و
            ايميل) درخواست اطلاعات كارت بانكي و رمز عبور آن را نخواهند داشت
          </p>
          <p>
            از رمزهای ساده استفاده نكنید. رمزهای خود را ترجیحاً به صورت تركیبی
            از حروف كوچك و بزرگ و اعداد و علامتها انتخاب نمایید.توصیه می شود: از
            انتخاب شماره شناسنامه، کد ملی و تاریخ تولد خود و یا خانواده ، پلاك
            خانه و شماره تلفن خودداری نمایید.
          </p>
          <p>
            رمز خود را جایی یادداشت نكنید و در صورت یادداشت نمودن آن را در جیب
            یا كیف پول به همراه كارت قرار ندهید.
          </p>
          <p>رمزهای عبور خود را به صورت دوره ای تغییر دهید.</p>
          <p>رمز خود را در اختیار سایر افراد قرار ندهید.</p>
          <p>
            اطلاعات حساس از جمله رمز خود را از طریق تلفن برای دیگران بازگو
            نكنید.
          </p>
          <p>
            در صورت فاش شدن رمز خود، در كوتاهترین زمان ممكن آن را عوض نمایید.
          </p>
          <p>
            كارت و رمز خود را به هیچ وجه در اختیار دیگران قرار ندهید . بعضاً
            افراد سود جو به بهانه كمك كردن و راهنمایی ضمن اخذ كارت و رمز شما پس
            از انجام عملیات كارت شما را با كارت دیگری (سرقتی ، مفقودی ، باطله
            و...) معاوضه نموده و حساب شما را مورد سوء استفاده قرار می دهند.
          </p>
          <p>
            در صورت انجام انتقال وجه و عملیات اینترنتی برروی حساب خود در
            مرورگرهای اینترنت گزینه ی به خاطرسپردن رمز را انتخاب نكنید. این
            گزینه با نام كلی Remember Password شناخته می شود، از این قابلیت
            استفاده نكنید.
          </p>
          <p>برای ارسال اطلاعات حساس خود از پست الكترونیكی استفاده ننمایید.</p>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Home"
};
</script>

<style scoped>
h2,
p {
  text-align: right;
}
</style>